module.exports = __webpack_public_path__ + "feature-backImg-d818821e.png";